import { Switch as SwitchMantine } from '@mantine/core'
import styled from 'styled-components'

export const Switch = styled(SwitchMantine)`
  .mantine-Switch-body {
    margin: 0;
  }

  .mantine-Switch-track {
    ${({ theme, checked }) => {
      const temaEscuro = theme.cor1 === '#000000'

      return `
        background-color: ${checked ? theme.cor11 : temaEscuro ? theme.cor59 : '#e9ecef'} !important;
        border-color: ${checked ? theme.cor11 : temaEscuro ? theme.cor59 : '#dee2e6'} !important;
      `
    }}
  }
`
